module.exports = __webpack_public_path__ + "media/images/lp_v6_img20-408e8c5d6432edf990c330e56c69e271.webp";